export default {
    props: ['leadsIdView'],
    data: () => ({
        messages: [],
        offerDetail: {
            status: '',
            patient_first_name: '',
            patient_last_name: '',
            insurance: '',
            body_parts: '',
            address: '',
            suit_apt: '',
            city: '',
            zip_code: '',
            region: '',
            home_phone: '',
            mobile_phone: '',
            notes: '',
            based_on_insurance: '',
            available_start_date: '',
            asap: false
        },
    }),
    watch: {
        async leadsIdView () {
            try {
                const res = await this.$newpetehealthapi.get(`/leads/${this.leadsIdView}/offer_details`);
                if (res && res.data) {
                    console.log('resData', res.data.leads_offer_details)
                    this.offerDetail = res.data.leads_offer_details
                }
            } catch (e) {
                console.log('data', this.posted_offers)
            }
        }
    },
}